import { render, staticRenderFns } from "./ipSave.vue?vue&type=template&id=5424e310&scoped=true"
import script from "./ipSave.vue?vue&type=script&lang=js"
export * from "./ipSave.vue?vue&type=script&lang=js"
import style0 from "./ipSave.vue?vue&type=style&index=0&id=5424e310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424e310",
  null
  
)

export default component.exports